import { render, staticRenderFns } from "./index.vue?vue&type=template&id=16b0706e&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=16b0706e&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16b0706e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\tx_projects\\plat-admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('16b0706e')) {
      api.createRecord('16b0706e', component.options)
    } else {
      api.reload('16b0706e', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=16b0706e&scoped=true", function () {
      api.rerender('16b0706e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/priceSetting/priceMonitoring/monitoringConfig/globalRules/index.vue"
export default component.exports